/* eslint-disable @typescript-eslint/no-explicit-any */
import { useClient } from '@composables/use-clients';
import { TenantType } from '@api/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';
import { PostRequestArgsType } from '@api/v1/types';

export type NewTenantSerializer = TenantType & {
  tenantUserCount: number;
  admins: Record<string, any>[];
};

export type PostNewTenantPayloadType = (
  Pick<NewTenantSerializer, 'name' | 'description'>
);
export type PostNewTenantResponseType = NewTenantSerializer;

export const apiCreateNewTenant = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostNewTenantPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.newTenant(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
